/**
 * Reads the logged-in farmer's identity from local storage.
 *
 * Recent-search history is a CITIZEN-only feature: a farmer signs in for
 * themselves (FarmerLoginForm / FarmerSelfRegistration), which persists the
 * standard rewamp session keys — `DfsWeb.access-token` (the auth token),
 * `DfsWeb.user-info` (the DIGIT UserRequest, carrying `uuid`/`tenantId`), and
 * `DfsWeb.isCitizenUser`. Every farmer-scoped rewamp reader uses these (e.g.
 * useAssets.js reads `DfsWeb.user-info`.uuid); there is NO `farmer.farmerInfo`
 * writer in the app.
 *
 * We deliberately gate on `isCitizenUser`: AGENT/employee sessions are excluded
 * because the API gateway rejects the AGENT role on `/recent-search/**` with 403
 * (assisted-mode history is out of scope), and guests have no identity at all.
 *
 * `tenantId` falls back to "br" — the single Bihar tenant the global-search
 * request already hardcodes — when the stored user-info omits it.
 */
export const getFarmerIdentity = () => {
  try {
    if (localStorage.getItem("DfsWeb.isCitizenUser") !== "true") return null;

    const authToken = localStorage.getItem("DfsWeb.access-token");
    const raw = localStorage.getItem("DfsWeb.user-info");
    if (!authToken || !raw) return null;

    const info = JSON.parse(raw);
    if (!info?.uuid) return null;

    return {
      uuid: info.uuid,
      authToken,
      tenantId: info.tenantId || "br",
    };
  } catch (e) {
    return null;
  }
};

export const isFarmerLoggedIn = () => getFarmerIdentity() !== null;
